import { useState, useEffect } from "react";
import { useSelections } from "../../context/Selections";

import PropTypes from "prop-types";
import styled from "styled-components";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
  gap: 10px;
`;

function DetailsDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("DN TOTAL");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const handleChange = (event) => {
    app.field("DN").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
    console.log(event.target.value);
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "DN")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app Details">

      <div className="appContent">

        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue="DN TOTAL"
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="DN TOTAL"
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="DN Total"
            />

            <FormControlLabel
              value="DN QUALIFICADA"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="DN Qualificada"
            />

            <FormControlLabel
              value="DN TOP"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="DN Top"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>

          <LayoutCardWrapper>

            <Card
              app={app}
              style={{
                width: "100%",
                height: "15%",
              }}
            >
              <div className="details-filters">
                <NativeObject
                  app={app}
                  key="PZrTe"
                  reference={{ id: "PZrTe" }}
                />
                <NativeObject
                  app={app}
                  key="afhgmM"
                  reference={{ id: "afhgmM" }}
                />
                <NativeObject
                  app={app}
                  key="NFpEPwa"
                  reference={{ id: "NFpEPwa" }}
                />
              </div>
            </Card>

            {selectedValue === "DN TOTAL" ? (
              <>

                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  exportContainer
                  exportTable
                  exportTableId="Ltapuy"
                >
                  <NativeObject
                    app={app}
                    key="Ltapuy"
                    reference={{ id: "Ltapuy" }}
                  />
                </Card>

                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  exportContainer
                  exportTable
                  exportTableId="yWDCS"
                >
                  <NativeObject
                    app={app}
                    key="yWDCS"
                    reference={{ id: "yWDCS" }}
                  />
                </Card>

              </>
            ) : null}

            {selectedValue === "DN QUALIFICADA" ? (
              <>

                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  exportContainer
                  exportTable
                  exportTableId="Ltapuy"
                >
                  <NativeObject
                    app={app}
                    key="Ltapuy"
                    reference={{ id: "Ltapuy" }}
                  />
                </Card>

                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  exportContainer
                  exportTable
                  exportTableId="yWDCS"
                >
                  <NativeObject
                    app={app}
                    key="yWDCS"
                    reference={{ id: "yWDCS" }}
                  />
                </Card>

              </>
            ) : null}

            {selectedValue === "DN TOP" ? (
              <>

                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  exportContainer
                  exportTable
                  exportTableId="Ltapuy"
                >
                  <NativeObject
                    app={app}
                    key="Ltapuy"
                    reference={{ id: "Ltapuy" }}
                  />
                </Card>

                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                  exportContainer
                  exportTable
                  exportTableId="yWDCS"
                >
                  <NativeObject
                    app={app}
                    key="yWDCS"
                    reference={{ id: "yWDCS" }}
                  />
                </Card>

              </>
            ) : null}

          </LayoutCardWrapper>

        </LayoutCardsWrapper>

      </div >

    </div >
  );
}

DetailsDesktop.defaultProps = {
  app: null,
  config: {},
};

DetailsDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailsDesktop;